import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './PuzzleGraphic.css';

const PuzzleGraphic = ({ onClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <motion.div
      className="puzzle-graphic"
      whileHover={{ scale: 1.05, rotate: -2 }}
      whileTap={{ scale: 0.95 }}
      onClick={onClick}
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
      title="Open Games"
    >
      <svg
        className="puzzle-svg"
        viewBox="0 0 140 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Watercolor paper background with torn edges */}
        <defs>
          <filter id="watercolorFilter" x="-20%" y="-20%" width="140%" height="140%">
            <feTurbulence type="fractalNoise" baseFrequency="0.04" numOctaves="3" result="noise" />
            <feDisplacementMap in="SourceGraphic" in2="noise" scale="3" xChannelSelector="R" yChannelSelector="G" />
          </filter>
          <linearGradient id="paperGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#faf6ef" />
            <stop offset="50%" stopColor="#f5ebe0" />
            <stop offset="100%" stopColor="#efe5d5" />
          </linearGradient>
          <linearGradient id="watercolorWash" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#d4e4ed" stopOpacity="0.4" />
            <stop offset="30%" stopColor="#e8d4c4" stopOpacity="0.3" />
            <stop offset="70%" stopColor="#dde4d4" stopOpacity="0.3" />
            <stop offset="100%" stopColor="#e4d4e0" stopOpacity="0.2" />
          </linearGradient>
        </defs>

        {/* Main paper shape with rough edges */}
        <path
          d="M 8,8
             Q 12,6 20,8
             L 35,7 Q 50,9 70,7 Q 90,6 110,8 L 125,7 Q 130,8 132,10
             L 133,25 Q 131,40 133,55 L 132,70 Q 134,80 132,90
             Q 130,93 125,92 L 110,93 Q 90,91 70,93 Q 50,94 35,92 L 20,93 Q 12,94 8,92
             Q 6,88 7,75 L 6,55 Q 8,40 6,25 L 7,12 Q 6,9 8,8 Z"
          fill="url(#paperGradient)"
          stroke="#c4a882"
          strokeWidth="1"
          filter="url(#watercolorFilter)"
        />

        {/* Watercolor wash overlay */}
        <path
          d="M 15,15 Q 70,12 125,18 L 120,82 Q 70,88 20,82 Z"
          fill="url(#watercolorWash)"
          opacity="0.6"
        />

        {/* Decorative header line - watercolor style */}
        <path
          d="M 20,28 Q 45,26 70,28 Q 95,30 120,28"
          stroke="#8b7355"
          strokeWidth="1.5"
          fill="none"
          opacity="0.6"
        />

        {/* "Games" text - handwritten style */}
        <text
          x="70"
          y="58"
          textAnchor="middle"
          fill="#5a4a3a"
          fontSize="24"
          fontFamily="var(--font-handwriting)"
          opacity="0.9"
        >
          Games
        </text>

        {/* Small decorative flourish */}
        <path
          d="M 45,68 Q 55,72 70,68 Q 85,72 95,68"
          stroke="#a08060"
          strokeWidth="1"
          fill="none"
          opacity="0.5"
        />

        {/* Coffee stain ring - subtle */}
        <circle
          cx="115"
          cy="25"
          r="12"
          fill="none"
          stroke="#c4a070"
          strokeWidth="2"
          opacity="0.15"
        />

        {/* Paper grain texture */}
        <rect
          x="8"
          y="8"
          width="124"
          height="84"
          fill="url(#grainTexture)"
          opacity="0.05"
        />

        <defs>
          <pattern id="grainTexture" x="0" y="0" width="3" height="3" patternUnits="userSpaceOnUse">
            <circle cx="1.5" cy="1.5" r="0.3" fill="#6b5644" />
          </pattern>
        </defs>
      </svg>
    </motion.div>
  );
};

export default PuzzleGraphic;
